

window.addEventListener("load", function () {
    const images = document.querySelectorAll('img[loading="lazy"]');

    const loadImage = (img) => {
        if (img.dataset.src) {
            img.src = img.dataset.src;
            img.addEventListener('load', () => {
                img.classList.add('loaded');
            });
        }
    };

    // 1. Native lazy load
    if ('loading' in HTMLImageElement.prototype) {
        images.forEach(img => loadImage(img));
    }
    // 2. Intersection Observer
    else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadImage(entry.target);
                    obs.unobserve(entry.target);
                }
            });
        });
        images.forEach(img => observer.observe(img));
    }
    // 3. Old browser , load ngay
    else {
        images.forEach(img => loadImage(img));
    }
});
